module.exports = __webpack_public_path__ + "img/problem-top-bg.3e3d2e69.png";